import { render, staticRenderFns } from "./xzl.vue?vue&type=template&id=5099859f&scoped=true&"
import script from "./xzl.vue?vue&type=script&lang=js&"
export * from "./xzl.vue?vue&type=script&lang=js&"
import style0 from "./xzl.vue?vue&type=style&index=0&id=5099859f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099859f",
  null
  
)

export default component.exports